const Swiper = require('swiper/dist/js/swiper.min');
const $ = require('jquery');

// Change the Header of the Slides according to the data-attributes
function changeSlideHeader(dataAttr) {
    $('[data-header=' + dataAttr + ']')
        .addClass('active')
        .siblings('[data-header]')
        .removeClass('active');
}

// Mark tab as active based on the current slides index
function markTabAsActive(instance) {
    var activeTab = $('[data-tab=' + instance.slides[instance.activeIndex].dataset.tabContent + ']');
    activeTab
        .siblings('[data-tab]')
        .removeClass('oc-section_tab--active');
    activeTab
        .addClass('oc-section_tab--active');
}

// Restart and Loop the Video (if exists) on slideChange
function restartAndLoopVideoSlide(instance, index) {
    if ($(instance.slides[index]).find('video').length) {
        var videoSlide = $(instance.slides[index]).find('video')[0];
        videoSlide.play();
        videoSlide.currentTime = 0;
        videoSlide.loop = true;
    }
}

module.exports = {
    getDefaultConfig: function () {
        return {
            direction: 'horizontal',
            centerSlides: true,
            grabCursor: true
        };
    },

    buildSlider: function (targetClassName, sliderCfg) {
        var slider = new Swiper(targetClassName, sliderCfg);

        slider.on('slideChange', function () {
            slider.$el.closest('section').find('.oc-section_tab').eq(slider.activeIndex).trigger('click');
        });

        // Call all related functions on tab click
        $('[data-tab]').on('click', function () {
            var tabAttr = $(this).attr('data-tab');

            // Determine if Slider one or two
            if ($(this).closest('section').find(targetClassName).length) {
                slider.slideTo($(this).index());
                changeSlideHeader(tabAttr);
                markTabAsActive(slider);
                restartAndLoopVideoSlide(slider, slider.activeIndex);
            }
        });

        return slider;
    }
};
